import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

/**
 * Opens a Bootstrap offcanvas alongside a Turbo Frame link click.
 *
 * Bootstrap's own data-bs-toggle="offcanvas" data-api calls
 * preventDefault() on <a> elements, which stops Turbo from loading the
 * link's target frame. This controller shows the offcanvas without
 * touching the event, so the offcanvas opens AND Turbo loads the frame.
 *
 * @example
 *   <a href="/admin/users/1"
 *      data-controller="offcanvas-link"
 *      data-offcanvas-link-target-value="#user-drawer"
 *      data-action="click->offcanvas-link#open"
 *      data-turbo-frame="user-drawer-frame">Details</a>
 */
export default class extends Controller {
  static values = { target: String }

  open() {
    const element = document.querySelector(this.targetValue)
    if (element) bootstrap.Offcanvas.getOrCreateInstance(element).show()
  }
}
